// src/components/Navbar.js
import React from 'react';
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { Link } from 'react-router-dom';
import '../AstroStyle.css';

export default function Navbar() {
    return (
        <nav className="navbar-grid">
            <div className="navbar-left">
                <a
                    href="https://thesimulacrum.xyz"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="navbar-logo"
                >
                    <img
                        className="navbar-logo-image"
                        src="/372.png"
                        alt="The Simulacrum Microwave Logo"
                    />
                </a>
                <div className="navbar-wallet">
                    <WalletMultiButton />
                </div>
            </div>

            <div className="navbar-links">
                <Link to="/About" className="nav-link">About</Link>
                <Link to="/" className="nav-link">Asteroid Visualizer</Link>
            </div>
        </nav>
    );
}
